import { getMicroChainFromServer } from "logic/services/MicroChain/server";
import { getMyProjectNetworkListFromServer } from "logic/services/Project/server";
import { getCurrencyFromServer } from "logic/services/currency/server";
import { WEB3 } from "modules/web3/Web3";
import { getListedContractDetailParser } from "parser/contractParser";
import { getTokenDetailParser } from "parser/currencyParser";
import { getNetworkLabelAndMicroChainLabelParser } from "parser/microChainParser";
import { getGasPriceFromServer } from "server/API/microChainAPI";
import Web3 from "web3";
import { actionController } from "../utils";

export const microChainController = {
  getGasPrice: async (microChainId: number) => {
    return await actionController(async () => {
      const { gas_price } = await getGasPriceFromServer({
        params: { microChainId },
      });
      if (gas_price) {
        return gas_price;
      } else {
        throw new Error("gas_not_found");
      }
    });
  },

  //getTokenDetailAction 참고
  //makeMintTokenTransaction을 위한 인자 생성
  getTokenDetail: async (currencyId: number) => {
    return await actionController(async () => {
      try {
        // tokenDetail 파싱
        const tokenDetail = await getTokenDetailParser(currencyId);

        // 네트워크 라벨과 마이크로체인 라벨을 가져옵니다.
        const { networkLabel, microChainLabel } =
          await getNetworkLabelAndMicroChainLabelParser(
            tokenDetail.originMicroChainId
          );

        // 해당하는 마이크로체인 통화 가져오기
        const originMicroChainCurrency = tokenDetail?.microChainCurrencies.find(
          (el) => el.microChainId === tokenDetail.originMicroChainId
        );

        // 트랜잭션 해시 설정
        let tokenContractTxHash: string | null = null;
        if (tokenDetail.mainStatus > 3 && originMicroChainCurrency) {
          const { transactionHash } = await getListedContractDetailParser(
            originMicroChainCurrency.contractId
          );
          tokenContractTxHash = transactionHash;
        }

        // 결과 객체 리턴
        return {
          ...tokenDetail,
          currencyDetail: {
            ...tokenDetail.currencyDetail,
            initialSupply: WEB3.fromWei(
              tokenDetail.currencyDetail.initialSupply
            ),
          },
          ...(originMicroChainCurrency && {
            originMicroChainCurrency: originMicroChainCurrency,
          }),
          transactionHash: tokenContractTxHash,
          networkLabel,
          microChainLabel,
        };
      } catch (error) {
        throw new Error("get_Token_detail_fail");
      }
    });
  },

  getMicroChainList: (option: {
    networkId?: number;
    microChainIds?: number[];
    projectId?: number;
    creatorId?: number;
  }) => {
    return actionController(async () => {
      try {
        const externalMicroChain = await getMicroChainFromServer({
          query: {
            ...(option.networkId && { networkId: option.networkId }),
            ...(option.microChainIds && {
              microChainIds: option.microChainIds,
            }),
            external: true,
            ...(option.projectId && { projectId: option.projectId }),
            ...(option.creatorId && { creatorId: option.creatorId }),
          },
        });
        const internalMicroChain = await getMicroChainFromServer({
          query: {
            ...(option.networkId && { networkId: option.networkId }),
            ...(option.microChainIds && {
              microChainIds: option.microChainIds,
            }),
            external: false,
            ...(option.projectId && { projectId: option.projectId }),
            ...(option.creatorId && { creatorId: option.creatorId }),
          },
        });
        const combinedMicroChain = [
          ...externalMicroChain,
          ...internalMicroChain,
        ];
        return combinedMicroChain;
      } catch (e) {
        throw new Error("microChain_get_fail");
      }
    });
  },

  getGasFee: () => {
    return actionController(async () => {
      const web3 = new Web3(window.ethereum);
      try {
        const gasPriceInWei = await web3.eth.getGasPrice();
        const gasPriceInEther = web3.utils.fromWei(gasPriceInWei, "ether");
        const gasPrice = {
          gasPriceInWei: gasPriceInWei,
          gasPriceInEther: gasPriceInEther,
        };
        return gasPrice;
      } catch (e) {
        throw new Error("gasPrice_get_fail");
      }
    });
  },

  getMyProjectNetworkDetail: async () => {
    return await actionController(async () => {
      try {
        const networkList = await getMyProjectNetworkListFromServer({});
        const microChainIds = networkList.map(
          (network) => network.micro_chain_id
        );
        const externalMicroChain = await getMicroChainFromServer({
          query: {
            microChainIds,
            external: true,
          },
        });
        const internalMicroChain = await getMicroChainFromServer({
          query: {
            microChainIds,
            external: false,
          },
        });

        // `originMicroChainIds`에 값을 넣은 후, 한 번에 `networkImage`를 가져옵니다.
        const networkImages = await getCurrencyFromServer({
          query: {
            originMicroChainIds: microChainIds,
          },
        });

        const combinedMicroChain = [
          ...externalMicroChain,
          ...internalMicroChain,
        ];

        const updatedNetworkList = networkList.map((network) => {
          const matchingMicroChain = combinedMicroChain.find(
            (microChain) => microChain.id === network.micro_chain_id
          );
          const matchingMicroChainImage = networkImages.find(
            (microChain) =>
              microChain.origin_micro_chain_id === network.micro_chain_id
          );

          return {
            ...network,
            network_detail: matchingMicroChain || null, // Add the corresponding network detail, or null if no match
            image: matchingMicroChainImage || null,
          };
        });

        return updatedNetworkList;
      } catch (error) {
        throw new Error("networkList_get_fail");
      }
    });
  },
};
